import { setCss } from './functions.js';

export default function GeocoderInputModule(element) {
    window.globalGeocoderCount = window.globalGeocoderCount || 0;
    window.globalGeocoderCount++;

    let hiddenInput = element.querySelector('input[type="hidden"]');

    let placeholder = element.getAttribute('kd-placeholder') || null;
    let enableGeolocation = element.getAttribute('kd-enable-geolocation') || false;
    let initialValue = element.getAttribute('kd-initial-value') || null;

    const geocoder = new MapboxGeocoder({
        accessToken      : mapboxgl.accessToken,
        types            : 'address, postcode, place, neighborhood, poi',
        language         : 'es',
        countries        : 'es',
        limit            : 10,
        proximity        : 'ip',
        placeholder      : placeholder,
        clearAndBlurOnEsc: true,
        enableGeolocation: enableGeolocation,
        addressAccuracy  : 'address',
        enableEventLogging: false,
    });

    function clearInput() {
        hiddenInput.value = '';
    }
    
    geocoder.on('loading', result => {
        clearInput();
    });
    geocoder.on('result', result => {
        hiddenInput.value = JSON.stringify(result.result);
        hiddenInput.dispatchEvent(new CustomEvent('change', { detail: result.result, bubbles: true }));
    });

    setCss(element, { zIndex: 10 - window.globalGeocoderCount });
    
    geocoder.addTo(element);

    setTimeout(function() { // Simulamos onload del campo, no lo proveen ellos
        geocoder._inputEl.autocomplete = 'street-address';
        if (initialValue) {
            geocoder._inputEl.value = initialValue;
        }
        geocoder._clearEl.addEventListener('click', () => {
            clearInput();
        });
        
    }, 1000);
}
